import React, { useContext, useReducer } from "react";
import AdminReducer from "../reducers/AdminReducer";

const AdminContext = React.createContext();

const initialState = {
  category: {
    modal: false,
    id: 0,
    category_name: "",
    category_short: "",
    list: [],
    refresh: 0,
  },
  article: {
    modal: false,
    id: 0,
    category_id: 0,
    article_name: "",
    users: [],
    departments: [],
    list: [],
    department_list: [],
    refresh: 0,
  },
  data: {
    id: 0,
    modal: false,
    list: [],
    files: [],
    article_id: undefined,
    data_name: "",
    url: "",
    loading: false,
    refresh: 0,
    s_department_name: "",
    s_data_name: "",
    s_article_name: "",
  },
};

export const useAdminState = () => {
  const context = useContext(AdminContext);
  if (context === undefined) {
    throw new Error(
      "useAdminState нь AdminContextProvider дотор ашиглагдах ёстой."
    );
  }
  return context;
};

const AdminContextProvider = ({ children }) => {
  const [admin, setAdmin] = useReducer(AdminReducer, initialState);

  return (
    <AdminContext.Provider
      value={{
        admin,
        setAdmin,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};

export default React.memo(AdminContextProvider);
